module.exports = __webpack_public_path__ + "static/media/view2.de0f7bf4.jpg";